/*
  Blok "Twoj prezent" - Dzien calowania 13.09.2026.
  Dodaje / podmienia / usuwa Non-transfer Lip Oil w koszyku.

  Ten skrypt NIE decyduje o cenie. Cene ustala rabat automatyczny w Shopify.
  Jesli skrypt padnie, klientka doda olejek recznie i rabat zadziala tak samo.
  Jesli skrypt doda olejek ponizej progu, rabat nie wejdzie i cena bedzie pelna,
  dlatego snippet pokazuje wtedy ostrzezenie zamiast po cichu kasowac pozycje.

  Odswiezanie: motyw przerysowuje tylko regiony z getSectionsToRender()
  w cart-items.js (ikona, naglowek, cart-items, pasek dostawy, stopka).
  Tego bloku tam nie ma, wiec musi odswiezac sie sam - inaczej zamarza
  z HTML sprzed zmiany koszyka. Sluchamy on:line-item:change, ktore motyw
  rozglasza po kazdej zmianie ilosci i po usunieciu pozycji.
*/
if (!customElements.get('lovro-prezent')) {
  class LovroPrezent extends HTMLElement {
    constructor() {
      super();
      this.loader = this.querySelector('.cart-item__loader');
      this.klikHandler = this.obsluzKlik.bind(this);
      this.koszykHandler = this.obsluzZmianeKoszyka.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.klikHandler);
      document.addEventListener('on:line-item:change', this.koszykHandler);
      document.addEventListener('on:cart:change', this.koszykHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.klikHandler);
      document.removeEventListener('on:line-item:change', this.koszykHandler);
      document.removeEventListener('on:cart:change', this.koszykHandler);
      clearTimeout(this.zwloka);
    }

    obsluzZmianeKoszyka() {
      if (this.zajety) return;
      clearTimeout(this.zwloka);
      this.zwloka = setTimeout(() => this.przerysuj(), 120);
    }

    obsluzKlik(evt) {
      if (this.zajety) return;

      if (evt.target.closest('[data-usun]')) {
        evt.preventDefault();
        this.usunPrezent();
        return;
      }

      const przycisk = evt.target.closest('[data-wariant]');
      if (!przycisk || przycisk.disabled) return;
      evt.preventDefault();
      if (przycisk.getAttribute('aria-current') === 'true') return;
      this.ustawOdcien(przycisk.dataset.wariant);
    }

    async ustawOdcien(idWariantu) {
      this.start();
      try {
        if (this.dataset.klucz) {
          await this.zmienLinie(this.dataset.klucz, 0);
        }
        await this.dodaj(idWariantu);
        await this.odswiez();
      } catch (blad) {
        console.error('[lovro-prezent] nie udalo sie ustawic prezentu', blad);
      } finally {
        this.koniec();
      }
    }

    async usunPrezent() {
      if (!this.dataset.klucz) return;
      this.start();
      try {
        await this.zmienLinie(this.dataset.klucz, 0);
        await this.odswiez();
      } catch (blad) {
        console.error('[lovro-prezent] nie udalo sie usunac prezentu', blad);
      } finally {
        this.koniec();
      }
    }

    async dodaj(idWariantu) {
      const dane = new FormData();
      dane.append('id', idWariantu);
      dane.append('quantity', '1');
      dane.append('properties[_prezent]', 'true');

      const odp = await fetch(this.dataset.urlAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: dane
      });
      if (!odp.ok) throw new Error('cart/add ' + odp.status);
      return odp.json();
    }

    async zmienLinie(klucz, ilosc) {
      const odp = await fetch(this.dataset.urlChange, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: klucz, quantity: ilosc })
      });
      if (!odp.ok) throw new Error('cart/change ' + odp.status);
      return odp.json();
    }

    /* Prosi motyw o przerysowanie jego wlasnych regionow, potem przerysowuje siebie. */
    async odswiez() {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true, cancelable: false
      }));
      await this.przerysuj();
    }

    /* Pobiera swiezy HTML sekcji koszyka i podmienia sam siebie. */
    async przerysuj() {
      if (!this.isConnected) return;

      const sekcja = document.querySelector('cart-items')?.dataset.section
        || document.querySelector('cart-drawer')?.dataset.section
        || document.getElementById('cart-summary')?.dataset.section
        || this.closest('.shopify-section')?.id.replace('shopify-section-', '');
      if (!sekcja) return;

      try {
        const odp = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(sekcja));
        if (!odp.ok) throw new Error('sections ' + odp.status);
        const dane = await odp.json();

        const tmpl = document.createElement('template');
        tmpl.innerHTML = dane[sekcja];
        const swiezy = tmpl.content.querySelector('lovro-prezent');

        if (!this.isConnected) return;
        if (swiezy) {
          this.replaceWith(swiezy);
        } else {
          this.innerHTML = '';
        }
      } catch (blad) {
        console.error('[lovro-prezent] nie udalo sie przerysowac bloku', blad);
      }
    }

    start() {
      this.zajety = true;
      this.classList.add('pointer-events-none', 'disabled');
      if (this.loader) this.loader.hidden = false;
    }

    koniec() {
      this.zajety = false;
      this.classList.remove('pointer-events-none', 'disabled');
      if (this.loader) this.loader.hidden = true;
    }
  }

  customElements.define('lovro-prezent', LovroPrezent);
}